import { mobileNumber, required, Spacer } from '@jfs/ui-new'
import { notRequired, optionalEmail } from '@jfs/ui-new/src/utils/validations'
import { DropdownOptimised } from '../../../../comps/DropdownNew'
import { FormText } from '../../../../comps/FormText'
import { LabeledComponent } from '../../../../comps/LabeledComponent'
import { profileStrings, staticStrings } from '../../../../data/static/strings'
import { leftHeaderTextbox } from '../../../../screens/PaymentLinks/CreatePaymentLink/LeftHeaderTextBox'
import { leftComponent } from '../../../../screens/SignupMobile/Signup'
import { name } from '../../../../util/regex'
import { AcessRightsCheckbox } from '../../AccessRightsCheckbox'
import { DropdownData } from './DropdownData'
import { SeparatorLine } from './SeparatorLine'

export const fieldCheckboxName = 'checkBoxFormData'

interface formDataInterface {
  dropdownValue: string
  onDropdownValueChange: (val: string) => void
  accessRightsData: any
  isEditScreen: boolean
  hasSupersetPermission: boolean
}

export const formData = ({
  dropdownValue,
  onDropdownValueChange,
  accessRightsData,
  isEditScreen,
  hasSupersetPermission = false,
}: formDataInterface) => {
  const checkBoxFormData = accessRightsData?.map((item: any, index: any) => {
    return {
      fieldName: `${fieldCheckboxName}_` + index,
      ComponentName: AcessRightsCheckbox,
      heading: item.type && item.type.toLowerCase() !== 'null' ? item.type : 'Miscellaneous',
      marginHorizontal: '6%',
      borderTopLeftRadius: index === 0 ? 4 : 0,
      borderTopRightRadius: index === 0 ? 4 : 0,
      borderBottomLeftRadius: index === accessRightsData.length - 1 ? 4 : 0,
      borderBottomRightRadius: index === accessRightsData.length - 1 ? 4 : 0,
      borderBottomWidth: index === accessRightsData.length - 1 ? 1 : 0,
      initialCheckBoxData: item.data,
      updateCheckBoxData: () => {},
    }
  })
  return [
    {
      verticalSpacing: 0,
      formItems: [
        {
          fieldName: 'userName',
          ComponentName: leftHeaderTextbox,
          textLabel: staticStrings.nameOfUser,
          validationSchema: name,
          disabled: isEditScreen,
          maxLength: 30,
          placeholder: '',
          borderColor: 'DISABLED_GREY',
          minWidth: 300,
        },
        {
          fieldName: 'spacer1',
          ComponentName: Spacer,
          size: 20,
        },
        {
          fieldName: 'mobile',
          ComponentName: leftHeaderTextbox,
          textLabel: staticStrings.mobNum,
          validationSchema: mobileNumber,
          maxLength: 10,
          disabled: isEditScreen,
          borderColor: 'DISABLED_GREY',
          placeholder: '',
          leftComponent: leftComponent('PRIMARY_GREY'),
          minWidth: 300,
        },
        {
          fieldName: 'spacer2',
          ComponentName: Spacer,
          size: 20,
        },
        {
          fieldName: 'email',
          ComponentName: leftHeaderTextbox,
          textLabel: profileStrings.email,
          validationSchema: optionalEmail,
          maxLength: 40,
          disabled: isEditScreen,
          placeholder: '',
          minWidth: 300,
          borderColor: 'DISABLED_GREY',
        },
        {
          fieldName: 'spacer3',
          ComponentName: Spacer,
          size: 20,
        },
        {
          fieldName: 'role',
          ComponentName: LabeledComponent,
          leftTextLabel: staticStrings.role,
          component: DropdownOptimised,
          placeHolder: dropdownValue ?? 'Choose role',
          data: DropdownData,
          dropDownContentFontSize: 12,
          chevronColor: 'BLUE',
          disabled: isEditScreen,
          dropdownWidth: 300,
          placeholderColor: 'DISABLED_GREY',
          minWidth: 300,
          testID: 'role-options',
          onChange: (val: any) => onDropdownValueChange(val),
          validationSchema: dropdownValue ? notRequired : required,
        },
        {
          fieldName: 'spacer4',
          ComponentName: Spacer,
          size: 30,
        },
        ...(hasSupersetPermission
          ? []
          : [
              {
                fieldName: 'separator',
                ComponentName: SeparatorLine,
              },
              {
                fieldName: 'spacer5',
                ComponentName: Spacer,
                size: 24,
              },
              {
                fieldName: 'accessRights',
                ComponentName: FormText,
                marginHorizontal: '6%',
                text: staticStrings.access_rights,
                color: 'BLACK_21',
                fontFamily: 'jioType-bold',
                fontSize: 12,
              },
              {
                fieldName: 'spacer6',
                ComponentName: Spacer,
                size: 24,
              },
              ...checkBoxFormData,
            ]),
      ],
    },
  ] as Array<any>
}
